import type { MenuSection } from '@1js/acui-menu/lib/components/MenuDefinition';
import type { IButtonStyles } from '@fluentui/react/lib/Button';
import type { ClientItemId } from 'owa-client-ids';
import { constructKeytip, getKeytipString } from 'owa-command-ribbon';
import { getDefaultSlrAppRibbonButtonStyles } from 'owa-command-ribbon-styles';
import { getControlInfo } from 'owa-mail-ribbon-utils';
import { MailRibbonControlId, MailRibbonTabId } from 'owa-ribbon-ids';
import { onDeleteClicked, onIgnoreStopIgnoreClicked } from '../../util/commandActions';
import { createMailAppButton } from '../../util/createMailRibbonButton';
import { getReadRibbonId } from '../../util/getReadRibbonId';

export default function getDeleteSections(itemId?: ClientItemId): MenuSection[] {
    const controlIgnoreInfo = getControlInfo(MailRibbonControlId.IgnoreStopIgnore);
    const controlDeleteInfo = getControlInfo(MailRibbonControlId.DeleteItem);
    const keytipPrefixSequence: string[] = [
        getKeytipString(MailRibbonTabId.Tab_Home),
        getKeytipString(MailRibbonControlId.DeleteItem),
    ];
    const styles: IButtonStyles = getDefaultSlrAppRibbonButtonStyles();

    return [
        {
            controls: [
                createMailAppButton(
                    getReadRibbonId(MailRibbonControlId.DeleteItem, itemId),
                    controlDeleteInfo.text,
                    controlDeleteInfo.tooltip,
                    itemId !== undefined /*isPopout*/,
                    onDeleteClicked(itemId),
                    constructKeytip(
                        keytipPrefixSequence,
                        getKeytipString(MailRibbonControlId.DeleteItem)
                    ),
                    controlDeleteInfo.iconName,
                    undefined /*iconColor*/,
                    styles
                ),
                createMailAppButton(
                    MailRibbonControlId.IgnoreStopIgnore,
                    controlIgnoreInfo.text,
                    controlIgnoreInfo.tooltip,
                    false /*isPopout*/,
                    onIgnoreStopIgnoreClicked,
                    constructKeytip(
                        keytipPrefixSequence,
                        getKeytipString(MailRibbonControlId.IgnoreStopIgnore)
                    ),
                    controlIgnoreInfo.iconName,
                    undefined /*iconColor*/,
                    styles
                ),
            ],
        },
    ];
}
